import { AgTechTabPageFlavorProps, AgTechTabPageTemplate, AgTechTabbedPageTab } from "../../../Pages/Tabbed/AgTechTabPage";

const AgTechBadgedTabPage = (props: AgTechTabPageFlavorProps & {
    tabClasses?: string,
    showBottomBorder?: boolean
}) => {
    const customTabClasses = props.tabClasses ?? '';
    const showBottomBorder = props.showBottomBorder ?? true;

    return (
        <AgTechTabPageTemplate
            {...props}
            panel={() => (
                <div className={`wide column-based non-bordered mb-4 container ${showBottomBorder ? 'pb-4 bottom-bordered' : ''} ${props.header?.classes ?? ''}`}>
                    {props.tabs.map(tab => (
                        <AgTechTabbedPageTab
                            key={tab.text}
                            {...tab}
                            classes={{
                                tab: `px-6 py-[6px] centered font-semibold rounded flex-initial bordered mr-4 hover:bg-highlight-100 ${customTabClasses}`,
                                active: '!bg-white'
                            }}
                        />
                    ))}
                    {props.header?.content && (
                        <div className="ml-auto my-auto container">
                            {props.header.content()}
                        </div>
                    )}
                </div>
            )}
        />
    )
}

export default AgTechBadgedTabPage;